import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import WidgetCard from './WidgetCard';
import { formatLocalDate, useWidgetData } from './useWidgetData';

interface NotificationItem {
  id: string;
  message: string;
  sender?: string;
  isRead: boolean;
  createdAt: string;
}

interface NotificationsResponse {
  notifications: NotificationItem[];
  unread: number;
}

const ACCENT = '#d97706';

/** Виджет «Последние уведомления» (на главной - два последних, прочитанные и нет). Право: home.notifications.view */
const NotificationsWidget: React.FC = () => {
  const { data, loading, error, reload } = useWidgetData<NotificationsResponse>('/api/v2/home/notifications');
  const items = data?.notifications || [];

  return (
    <WidgetCard
      title="Последние уведомления"
      icon={<NotificationsNoneIcon />}
      accent={ACCENT}
      headerExtra={
        data && data.unread > 0 ? (
          <Chip size="small" label={`${data.unread} нов.`} sx={{ height: 22, bgcolor: '#fef3c7', color: '#b45309', fontWeight: 600, fontSize: 12 }} />
        ) : undefined
      }
      loading={loading}
      error={error}
      onRefresh={reload}
    >
      {!loading && items.length === 0 ? (
        <Typography sx={{ p: 2, fontSize: 13, color: '#94a3b8' }}>Уведомлений пока нет</Typography>
      ) : (
        items.map((n, i) => (
          <Box
            key={n.id}
            sx={{
              display: 'flex', gap: 1.25, px: 2, py: 1.25,
              borderTop: i ? '1px solid #f1f5f9' : 'none',
              bgcolor: n.isRead ? 'transparent' : '#fffbeb'
            }}
          >
            <Box
              sx={{
                width: 8, height: 8, borderRadius: '50%', mt: '7px', flexShrink: 0,
                bgcolor: n.isRead ? '#e2e8f0' : ACCENT
              }}
            />
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: 13.5, lineHeight: 1.45, color: n.isRead ? '#64748b' : '#0f172a', fontWeight: n.isRead ? 400 : 500,
                  display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden'
                }}
              >
                {n.message}
              </Typography>
              <Typography sx={{ mt: 0.25, fontSize: 12, color: '#94a3b8' }}>
                {formatLocalDate(n.createdAt)}{n.sender ? ` · ${n.sender}` : ''}
              </Typography>
            </Box>
          </Box>
        ))
      )}
    </WidgetCard>
  );
};

export default NotificationsWidget;
